<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div>
        <div v-if="role===0 || role===1" class="table-top-wrapper">
            <el-row>
                <el-col :span="24" class="condition-panel"
                        style="display: flex;flex-direction: row;justify-content: space-between;">
                    <el-col :span="2">
                        <el-button type="primary" v-if="role===0" @click="handleAttractionDialog(1)">添加</el-button>
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-direction: row;justify-content: end;">
                        <el-form :inline="true">
                            <!--HH:mm:ss-->
                            <el-form-item label="名称" style="margin-right: 10px !important;">
                                <el-input @input="getAttraction(true)" v-model="attractionSelect.attraction.name"
                                          type="text"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="margin-left: 20px;" @click="reset()" type="danger">重置</el-button>
                                <el-button style="margin-left: 20px;" @click="getAttraction(true)" type="primary">查询
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-col>
            </el-row>
        </div>

        <div class="table-wrapper">
            <el-table
                    :header-cell-style="$store.state.style.table.headerCellStyle"
                    :cell-style="$store.state.style.table.cellStyle"
                    :header-row-style="$store.state.style.table.headerRowStyle"
                    :row-style="$store.state.style.table.rowStyle"
                    :row-class-name="tableClass"
                    border
                    key="AttractionManage"
                    width="100%"
                    :data="attractions">
                <el-table-column label="ID" prop="id"></el-table-column>
                <el-table-column label="图片列表">
                    <template slot-scope="scope">
                        <div style="display: flex;gap: 10px;padding: 0 10px ">
                            <img :src="$store.state.backendHost+o"
                                 style="cursor: pointer"
                                 height="50px" alt=""
                                 @click="openFullscreen($store.state.backendHost+o)"
                                 v-for="(o,i) in scope.row.imgs.split(',')"
                                 :key="i"></div>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="经度" prop="lon"></el-table-column>
                <el-table-column label="纬度" prop="lat"></el-table-column>
                <el-table-column label="地址" prop="address"></el-table-column>
                <el-table-column label="介绍" prop="intro"></el-table-column>
                <el-table-column width="380" label="操作">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: center;flex-direction: row">
                            <el-button v-if="role===0" type="primary" @click="handleAttractionDialog(2,scope.row)"
                                       icon="el-icon-edit"></el-button>
                            <el-popover
                                    v-if="role===0 && scope.row.role !==0"
                                    placement="top"
                                    key="AttractionManage"
                                    style="margin-left: 10px"
                                    v-model="scope.row.visible">
                                <p style="text-align: center">真的要删除吗?</p>
                                <div>
                                    <el-button type="danger" @click="deleteAttraction(scope.row,scope.$index)">确定
                                    </el-button>
                                    <el-button type="success" @click="scope.row.visible=false">取消</el-button>
                                </div>
                                <el-button icon="el-icon-delete" type="danger" slot="reference"></el-button>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pg-wrapper">
                <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="attractionSelect.pageVo.pageIndex"
                        :page-size.sync="attractionSelect.pageVo.pageSize"
                        @size-change="getAttraction(false)"
                        @current-change="getAttraction(false)"
                        :page-sizes="[5, 10, 50, 100]"
                        :total.sync="attractionSelect.pageVo.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="attractionDialogVisible" width="40%" :close-on-click-modal="false">
            <el-form label-width="150px" label-position="left" :model="attraction">
                <el-form-item label="名称" style="margin-right: 10px !important;">
                    <el-input v-model="attraction.name" type="text"></el-input>
                </el-form-item>
                <el-form-item label="经度" style="margin-right: 10px !important;">
                    <el-input v-model="attraction.lon" type="text"></el-input>
                </el-form-item>
                <el-form-item label="纬度" style="margin-right: 10px !important;">
                    <el-input v-model="attraction.lat" type="text"></el-input>
                </el-form-item>

                <el-form-item label="地址" style="margin-right: 10px !important;">
                    <el-input v-model="attraction.address" type="text"></el-input>
                </el-form-item>
                
                <el-form-item label="介绍" style="margin-right: 10px !important;">
                    <el-input v-model="attraction.intro" type="text"></el-input>
                </el-form-item>
                <el-form-item label="图片列表">
                    <multi-img-uploader v-model="attraction.imgs"></multi-img-uploader>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           <el-button @click="attractionDialogVisible = false">取消</el-button>
           <el-button type="primary" @click="handleAttractionDialogConfirm">保存</el-button>
       </span>
        </el-dialog>

        <!-- 全屏查看模态框 -->
        <div v-if="isFullscreen" class="fullscreen-overlay" @click="closeFullscreen">
            <img :src="fullscreenImage" class="fullscreen-image" />
        </div>
        
    </div>
</template>
<script>
import MultiImgUploader from '@/components/MultiImgUploader.vue'

export default {
    name: "AttractionManage",
    components: {MultiImgUploader},
    watch: {},
    data() {
        return {
            role: this.$store.state.loginUser.role,
            attractionSelect: {
                attraction: {
                    name: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            attraction: {
                id: null,
                imgs: '',
                name: '',
                lon: '',
                lat: '',
                intro: '',
                address: '',
            },
            attractions: [],
            selectedAttraction: {},
            attractionDialogMode: 1,
            attractionDialogVisible: false,
            isFullscreen: false,
            fullscreenImage: '',
            
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {
        openFullscreen(image) {
            this.fullscreenImage = image;
            this.isFullscreen = true;
        },
        closeFullscreen() {
            this.isFullscreen = false;
            this.fullscreenImage = '';
        },
        
        reset() {
            this.attractionSelect.attraction = {}
            this.getAttraction(true)
        },
        //crud
        insertAttraction() {
            let data = JSON.stringify(this.attraction)
            this.$axios({
                url: "/attraction/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.attraction.id = r.data
                    this.attractions.push(this.attraction)
                    this.attractionSelect.pageVo.total++
                    this.$message.success('创建成功');
                } else {
                    this.$message.error('创建失败');
                }
            })
        },
        dup(o) {
            this.attraction = o
            this.insertAttraction()
        },
        deleteAttraction(attraction, index) {
            this.$axios({
                url: "/attraction/delete?id=" + attraction.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.attractions.splice(index, 1)
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败');
                }
            })
        },
        modifyAttraction() {
            let data = JSON.stringify(this.attraction)
            this.$axios({
                url: "/attraction/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            })
        },
        getAttraction(resetPageIndex) {
            if (resetPageIndex) {
                this.attractionSelect.pageVo.pageIndex = 1
            }
            let data = JSON.stringify(this.attractionSelect)
            this.$axios({
                url: "/attraction/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.attractions = r.data.attractions
                this.attractionSelect.pageVo.total = r.data.total
            })
        },
        //crud public
        handleAttractionDialog(mode, attraction) {
            this.attractionDialogMode = mode
            this.attractionDialogVisible = true
            if (mode === 1) {
                this.attraction = {
                    id: null,
                    imgs: '',
                    name: '',
                    lon: '',
                    lat: '',
                    intro: '',
                    address: '',
                }
            }
            if (mode === 2) {
                this.attraction = attraction
            }
        },
        handleAttractionDialogConfirm() {
            if (this.attractionDialogMode === 1) this.insertAttraction()
            if (this.attractionDialogMode === 2) this.modifyAttraction()
            this.attractionDialogVisible = false
        },
        submitUpload() {
            this.$refs.upload.submit()
        },
        uploadSucc(response, file) {
            this.attraction.imgs = response
        },
        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}
.fullscreen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.fullscreen-image {
    max-width: 90%;
    max-height: 90%;
}

</style>